import React from 'react';
import { Redirect } from 'react-router-dom';
// import axios from 'axios';

// const test = () => {
//     return axios
//     .post('/LoginAttempt', {

//     })
// }

class LoginParse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      successful: null,
    };
  }

  componentDidMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    let success = params.get('successful');
    success = success === 'true';
    const errorMessage = success ? '' : params.get('error');

    this.setState({
      error: errorMessage,
      successful: success,
    });
  }

  render() {
    return (
      <div>
        {this.state.successful !== null ?
          this.state.error !== null ?
            <Redirect
              to={{
                pathname: '/',
                state: { error: this.state.error },
              }}
            />
            :
            <Redirect
              to={{
                pathname: '/PatientList',
              }}
            />

          :
          null
        }
        {/* 
        When this is used correctly, we will be able to see an error message appear on the front page

        {this.state.error !== null ?
                <Redirect
                    to={{
                        pathname: "/",
                        state: { error: this.state.error }
                    }}
                />
            :
                <Redirect
                    to={{
                        pathname: "/PatientList",
                    }}
                />
            } */}
            ok
      </div>
    );
  }
}

export default LoginParse;



// WEBPACK FOOTER //
// ./src/containers/Login/LoginParse.js